import { useState } from "react";
import { useApplicator } from "../context/ApplicatorContext";
import { Pencil } from "lucide-react";

export default function UpdateSIPPInstaller() {
  const { companyName, setCompanyName } = useApplicator();
  const [tempName, setTempName] = useState(companyName);
  const [showForm, setShowForm] = useState(false);

  const handleSave = (e) => {
    e.preventDefault();
    // Update context
    setCompanyName(tempName);
    // Update localStorage
    localStorage.setItem("companyName", tempName);
    setShowForm(false); // hide form after save
  };

  return (
    <div className="tw-my-3">
      {/* Toggle Button */}
      <button
        type="button"
        onClick={() => setShowForm((prev) => !prev)}
        className="tw-inline-flex tw-items-center tw-mr-6 tw-gap-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-transparent hover:tw-text-[#009ECC] tw-transition-colors"
      >
        <Pencil className="tw-w-4 tw-h-4 hover:tw-bg-transparent focus:tw-bg-transparent" />
        {showForm ? "" : ""}
      </button>

      {/* Conditional Form Card */}
      {showForm && (
        <form
          onSubmit={handleSave}
          className="tw-bg-white tw-p-4 tw-rounded-2xl tw-shadow-md tw-border tw-border-gray-200 tw-mt-4 tw-space-y-3 tw-max-w-md"
        >
          <h2 className="tw-text-lg tw-font-semibold tw-text-gray-800">
            Update Company Name
          </h2>
          <p className="tw-text-sm tw-text-gray-500">
            Change your company name locally. This does not update the backend.
          </p>

          <div className="tw-flex tw-items-center tw-gap-3">
            <input
              id="tempName"
              type="text"
              value={tempName || ""}
              onChange={(e) => setTempName(e.target.value)}
              placeholder="Enter new company name"
              className="tw-flex-1 tw-rounded-lg tw-border tw-border-gray-300 tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-[#00B5ED]"
            />
            <button
              type="submit"
              className="tw-bg-[#00B5ED] hover:tw-bg-[#009ECC] tw-text-white tw-font-medium tw-rounded-lg tw-px-4 tw-py-2 tw-text-sm tw-transition-colors"
            >
              Save
            </button>
          </div>

          <div className="tw-text-xs tw-text-gray-400 tw-mt-1">
            Current name:{" "}
            <span className="tw-font-semibold">{companyName}</span>
          </div>
        </form>
      )}
    </div>
  );
}
